export default "__VITE_ASSET__BkTo4sZk__"